import React from 'react';

const FetchFillIcon = ({ colour = '#E36414', width = '24', height = '24', className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_3692_3275)">
                <mask
                    id="mask0_3692_3275"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_3692_3275)">
                    <path
                        d="M12.2205 19.6198L15.2547 16.6122L12.2205 13.6046L11.1026 14.7224L12.2471 15.8669C11.7503 15.8847 11.2668 15.8048 10.7965 15.6274C10.3263 15.4499 9.90491 15.1749 9.53228 14.8023C9.1774 14.4474 8.90681 14.0393 8.72049 13.5779C8.53418 13.1166 8.44103 12.6553 8.44103 12.1939C8.44103 11.8923 8.48095 11.5906 8.5608 11.289C8.64065 10.9873 8.75155 10.6945 8.8935 10.4106L7.7224 9.23954C7.42075 9.68314 7.19895 10.1534 7.057 10.6502C6.91504 11.147 6.84407 11.6527 6.84407 12.1673C6.84407 12.8416 6.97715 13.507 7.24331 14.1635C7.50947 14.82 7.89984 15.4056 8.41441 15.9201C8.92899 16.4347 9.50567 16.8207 10.1444 17.0779C10.7832 17.3352 11.4398 17.4727 12.114 17.4905L11.1026 18.5019L12.2205 19.6198ZM16.6121 15.095C16.9138 14.6515 17.1356 14.1812 17.2775 13.6844C17.4195 13.1876 17.4905 12.6819 17.4905 12.1673C17.4905 11.493 17.3618 10.8232 17.1045 10.1578C16.8472 9.49239 16.4613 8.9024 15.9467 8.38783C15.4322 7.87325 14.851 7.49175 14.2034 7.24334C13.5557 6.99492 12.8948 6.87071 12.2205 6.87071L13.2319 5.83269L12.114 4.71482L9.07981 7.72243L12.114 10.73L13.2319 9.61216L12.0608 8.44106C12.5399 8.44106 13.0278 8.53421 13.5247 8.72053C14.0215 8.90684 14.4474 9.17743 14.8022 9.53231C15.1571 9.88719 15.4277 10.2953 15.614 10.7566C15.8003 11.218 15.8935 11.6793 15.8935 12.1407C15.8935 12.4423 15.8536 12.744 15.7737 13.0456C15.6939 13.3473 15.583 13.64 15.441 13.9239L16.6121 15.095ZM12.1673 22.8137C10.6945 22.8137 9.31048 22.5342 8.01517 21.9753C6.71986 21.4163 5.59312 20.6578 4.63494 19.6996C3.67677 18.7414 2.91821 17.6147 2.35928 16.3194C1.80034 15.0241 1.52087 13.64 1.52087 12.1673C1.52087 10.6945 1.80034 9.31051 2.35928 8.0152C2.91821 6.71989 3.67677 5.59315 4.63494 4.63497C5.59312 3.6768 6.71986 2.91824 8.01517 2.35931C9.31048 1.80037 10.6945 1.5209 12.1673 1.5209C13.64 1.5209 15.024 1.80037 16.3194 2.35931C17.6147 2.91824 18.7414 3.6768 19.6996 4.63497C20.6578 5.59315 21.4163 6.71989 21.9752 8.0152C22.5342 9.31051 22.8137 10.6945 22.8137 12.1673C22.8137 13.64 22.5342 15.0241 21.9752 16.3194C21.4163 17.6147 20.6578 18.7414 19.6996 19.6996C18.7414 20.6578 17.6147 21.4163 16.3194 21.9753C15.024 22.5342 13.64 22.8137 12.1673 22.8137Z"
                        fill={colour}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3692_3275">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default FetchFillIcon;
